"use strict";

const HardAssetInventoryGeneralInfo = function () {
  const stringKey = "hard-asset-general-info";
  const headerInformation = "General Info";
  let $page;
  let sections = [];

  var getStringKey = function () {
    return stringKey;
  };

  var getHeaderInformation = function () {
    return headerInformation;
  };

  var render = async function () {
    renderPage();
  };

  var renderPage = function (resolvedSections = resolveSections()) {
    renderPageHtml(resolvedSections);
    loadListeners();
    HardAssetInventoryModalController.highlightMissingRequiredFields();
  };

  var resolveSections = function () {
    return HardAssetInventoryFields.getSections(
      HardAssetInventoryModalController.getAssetType(),
      HardAssetInventoryModalController.getInventoryForRender(),
    );
  };

  var renderPageHtml = function (resolvedSections) {
    sections = resolvedSections;

    const html = nunjucks.render("modals/hardAssetInventory/hardAssetInventoryGeneralInfo.njk", {
      sections,
    });

    HardAssetInventoryModalController.renderPageContent(html);
    $page = $(".modal-dynamic-content");
  };

  var loadListeners = function () {
    for (const fieldName of HardAssetInventoryFields.getWatchedFieldNames(sections)) {
      $page.on("2N:FormInput", `[name="${fieldName}"]`, onConditionFieldChange);
    }

    Form.initializeAndLoadListeners(
      $page,
      HardAssetInventoryModalController.getInventoryFormKey(),
      {
        isMultiPart: true,
      },
    );

    initializeFileDropzones();
  };

  var initializeFileDropzones = function () {
    const formKey = HardAssetInventoryModalController.getInventoryFormKey();

    for (const field of HardAssetInventoryFields.getFileFields(sections)) {
      const dropzone = Form.initializeDropzone(
        formKey,
        $page.find(`[data-field="${field.name}"]`),
        {
          newFiles: Form.getFormDataAtPath(formKey, [field.name]),
          existingFiles: HardAssetInventoryModalController.getExistingData(field.name) ?? [],
          maxNumberFiles: field.singleFile ? 1 : null,
        },
      );

      dropzone.setDownloadHandler((filename) =>
        HardAssetInventoryModalController.downloadInventoryFile(filename, field.name),
      );
    }
  };

  var removeListeners = function () {
    for (const fieldName of HardAssetInventoryFields.getWatchedFieldNames(sections)) {
      $page.off("2N:FormInput", `[name="${fieldName}"]`, onConditionFieldChange);
    }
  };

  // A condition can change which fields are shown, which are required and the sections themselves,
  // so the whole page is rendered again from the updated inventory
  var onConditionFieldChange = function (event, value, pathParts) {
    const hasDerivedUpdates = applyDerivedUpdates(pathParts[0]);
    const resolvedSections = resolveSections();

    if (!hasDerivedUpdates && !conditionsChanged(resolvedSections)) {
      return;
    }

    const $focused = $page.find(":focus");
    const focusedInputName = $focused.attr("name");
    const caretPosition = $focused.prop("selectionStart");

    removeListeners();
    renderPage(resolvedSections);
    restoreFocus(focusedInputName, caretPosition);
  };

  var conditionsChanged = function (resolvedSections) {
    return (
      HardAssetInventoryFields.getConditionSignature(resolvedSections) !==
      HardAssetInventoryFields.getConditionSignature(sections)
    );
  };

  // AutoNumeric selects the whole number on focus, which would make the next keystroke replace it
  var restoreFocus = function (inputName, caretPosition) {
    if (!inputName) {
      return;
    }

    const $input = $page.find(`[name="${inputName}"]`);
    $input.trigger("focus");

    if (typeof caretPosition === "number" && typeof $input.prop("selectionStart") === "number") {
      $input[0].setSelectionRange(caretPosition, caretPosition);
    }
  };

  // Only the rules reading the answer the user just changed run
  var applyDerivedUpdates = function (changedFieldName) {
    const updates = HardAssetInventoryFields.getDerivedUpdates(
      HardAssetInventoryModalController.getAssetType(),
      HardAssetInventoryModalController.getInventoryForRender(),
      changedFieldName,
    );

    for (const fieldName in updates) {
      HardAssetInventoryModalController.setFormDataField(fieldName, updates[fieldName]);
    }

    return Object.keys(updates).length > 0;
  };

  var cleanUp = function () {
    removeListeners();
    $page.empty();
    return true;
  };

  var validate = function () {
    return true;
  };

  return {
    getStringKey,
    getHeaderInformation,
    render,
    cleanUp,
    validate,
  };
};

module.exports = HardAssetInventoryGeneralInfo();

const Form = require("../../general/form");
const HardAssetInventoryFields = require("./hardAssetInventoryFields");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
